module.exports = __webpack_public_path__ + "img/ON.aea034a5.png";